var TES = TES || {};

// These should match the values in https://github.com/tes/sass/blob/master/variables/_responsive.scss
TES.breakpoints = {
  XS: 480,
  SM: 768,
  MD: 992,
  LG: 1200
};

if (Modernizr && Modernizr.mq) {
  TES.viewportWidth = {
    small: {
      down: function() {
        return Modernizr.mq('only screen and (max-width: ' + (TES.breakpoints.SM - 1) + 'px)')
      }
    },
    medium: {
      up:  function() {
        return Modernizr.mq('only screen and (min-width: ' + TES.breakpoints.SM + 'px)')
      }
    },
    large: {
      up:  function() {
        return Modernizr.mq('only screen and (min-width: ' + TES.breakpoints.MD + 'px)')
      }
    }
  };
}
